<template>
  <div class="page-container">
    <div class="page-title-container d-flex justify-content-between align-items-center">
      <h1 class="page-title mb-0">Control de lavados</h1>
      <div>
        <b-button variant="none" class="button button-light mr-2" :to="{ name: 'fleet-wash-list' }">
          <i class="ri-history-line mr-1"></i> Historial
        </b-button>
        <b-button variant="none" class="button button-primary" :to="{ name: 'fleet-wash-create' }">
          <i class="ri-add-line mr-1"></i> Registrar lavado
        </b-button>
      </div>
    </div>

    <!-- Leyenda de alertas -->
    <div class="legend mb-3">
      <span class="legend-item"><span class="dot green"></span> Al día (&lt;10 días)</span>
      <span class="legend-item"><span class="dot yellow"></span> Atención (10–15 días)</span>
      <span class="legend-item"><span class="dot red"></span> Urgente (&gt;15 días o sin registro)</span>
    </div>

    <div class="table-container">
      <div class="table-responsive mb-0 table-min-height">
        <table class="custom-table w-100">
          <thead>
            <tr>
              <th class="pl-3">Vehículo</th>
              <th>Último lavado</th>
              <th>Días sin lavado</th>
              <th>Alerta</th>
              <th>Lavados del mes</th>
              <th class="pr-md-4">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in rows" :key="r.vehicle_id">
              <td class="text-center pl-3 font-weight-bold">{{ r.vehicle_plate }}</td>
              <td class="text-center">{{ r.last_wash_date ? formatDate(r.last_wash_date) : '—' }}</td>
              <td class="text-center">
                <span v-if="r.days_since != null">{{ r.days_since }} días</span>
                <span v-else class="text-muted">Nunca lavado</span>
              </td>
              <td class="text-center">
                <span :class="`badge ${alertMeta(r.alert).color}`">{{ alertMeta(r.alert).label }}</span>
              </td>
              <td class="text-center">
                <span :class="{ 'text-warning font-weight-bold': r.month_count >= 2 }">
                  {{ r.month_count }}/2
                </span>
                <i v-if="r.month_count >= 2" class="ri-alert-line text-warning ml-1"
                  v-b-tooltip.hover title="Alcanzó o superó el máximo sugerido de lavados del mes"></i>
              </td>
              <td class="text-center d_option pr-md-3">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem text="Registrar lavado"
                      @click="$router.push({ name: 'fleet-wash-create', query: { vehicle_id: r.vehicle_id } })" />
                    <DropdownItem text="Ver historial"
                      @click="$router.push({ name: 'fleet-wash-list', query: { vehicle_id: r.vehicle_id } })" />
                  </template>
                </DropdownTable>
              </td>
            </tr>
            <tr v-if="!rows.length">
              <td colspan="6" class="text-center text-muted py-4">No hay vehículos activos en esta ciudad.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert, DropdownTable, DropdownItem } from 'wize-admin'
import { FleetWashService } from '@/core/services'

const ALERTS = {
  green: { label: 'Al día', color: 'badge-green' },
  yellow: { label: 'Atención', color: 'badge-yellow' },
  red: { label: 'Urgente', color: 'badge-danger' }
}

export default {
  name: 'WashStatus',
  components: { DropdownTable, DropdownItem },
  data() {
    return { rows: [] }
  },
  methods: {
    alertMeta(a) { return ALERTS[a] || { label: a, color: 'badge-secondary' } },
    formatDate(value) {
      if (!value) return '—'
      const parts = String(value).slice(0, 10).split('-')
      if (parts.length !== 3) return value
      return `${parts[2]}/${parts[1]}/${parts[0]}`
    },
    async loadData() {
      try {
        await this.$store.dispatch('app/loading', true)
        const res = await FleetWashService.status()
        this.rows = res.payload || []
      } catch (e) {
        console.error(e)
        Alert.error(e.errors ? e.errors.message : 'Error al obtener el estado de lavados')
      } finally {
        await this.$store.dispatch('app/loading', false)
      }
    }
  },
  async mounted() {
    await this.loadData()
  }
}
</script>

<style lang="stylus" scoped>
.legend
  display flex
  flex-wrap wrap
  gap 18px
  font-size 12px
  color #6c757d
.legend-item
  display flex
  align-items center
  gap 6px
.dot
  width 10px
  height 10px
  border-radius 50%
  display inline-block
  &.green
    background #25C26E
  &.yellow
    background #f59e0b
  &.red
    background #dc3545
</style>
